import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import SideNavBar from "../common/SideNav/SideNavBar";
import Header from "../common/Header/Header";
import CreateCity from "../pages/City Management/CreateCity/CreateCity";
import CityManagement from "../pages/City Management/CityManagement";
import UpdateCity from "../pages/City Management/UpdateCityManagement/UpdateCity";
import ProductCatalogueManagement from "../pages/product-catalogue-management/ProductCatalogueManagement";
import ProductForCommanOutelet from "../pages/product-catalogue-management/Product For Comman Outlet/ProductForCommanOutelet";
import AddProductCatalogue from "../pages/product-catalogue-management/Product-catalogue Add Product/AddProductCatalogue";
import ProductCatalogueDetails from "../pages/product-catalogue-management/product-catalogue-details/ProductCatalogueDetails";
import OrderManagment from "../pages/order-managment/OrderManagment";
import OrderCompleted from "../pages/order-managment/order-completed/OrderCompleted";
import OrderReturnd from "../pages/order-managment/order-returnd/OrderReturnd";
import ConfirmedBooking from "../pages/order-managment/Active Booking/Confirmed Booking/ConfirmedBooking";
import InTransitOrders from "../pages/order-managment/Active Booking/In-Transit-Orders/InTransitOrders";
import OrderActiveConfirmDetails from "../pages/order-managment/order-active-confirm-details/OrderActiveConfirmDetails";
import OrderActiveInTransitDetails from "../pages/order-managment/order-active-in-transit-details/OrderActiveInTransitDetails";
import AddDecoratorPartnerDetails from "../pages/order-managment/Active Booking/Confirmed Booking/AddDecoratorPartnerDetails";
import CancelOrder from "../pages/order-managment/Active Booking/Confirmed Booking/CancelOrder";
import AbandonedCartOutletCommon from "../pages/abandoned-cart-managment/AbandonedCartOutlet.jsx/AbandonedCartOutletCommon";
import AbandonedCartManagment from "../pages/abandoned-cart-managment/AbandonedCartManagment";
import AbandonedDetails from "../pages/abandoned-cart-managment/abandoned-details/AbandonedDetails";
import AbandonedCartNotify from "../pages/abandoned-cart-managment/abandoned-Cart-Notify Management/AbandonedCartNotify";
import ContentManagement from "../pages/content-Management/ContentManagement";
import EditContentManagement from "../pages/content-Management/EditContentManagement";
import ContentManagementOutlet from "../pages/content-Management/ContentManagementOutlet";
import ProductCatalogueEdit from "../pages/product-catalogue-management/Prouduct-Catalogue Edit/ProductCatalogueEdit";
import Notification from "../pages/notification/Notification";
import AddNotification from "../pages/notification/Add Notification/AddNotification";
import UpdateNotification from "../pages/notification/Update Notification/UpdateNotification";
import ProductCategory from "../pages/product-category/ProductCategory";
import AddCategory from "../pages/product-category/Add Category/AddCategory";
import SubCategoryProduct from "../pages/product-category/product-sub-category/SubCategoryProduct";
import AddSubCategory from "../pages/product-category/product-sub-category/Add Sub Category/AddSubCategory";
import ProductCategoryOutlet from "../pages/product-category/ProductCategoryOutlet";
import EditCategory from "../pages/product-category/Edit Category/EditCategory";
import BannerManagement from "../pages/Banner Management/BannerManagement";
import MetaDataManagement from "../pages/MetaDataManagment/MetaDataManagement";
import AddMetaCategory from "../pages/MetaDataManagment/addMetaDataCategory/AddMetaCategory";
import AddMetaSubCategory from "../pages/MetaDataManagment/addMetaDataSubCategory/addMetaSubCategory";
import TopBanners from "../pages/Banner Management/Top Banner/TopBanners";
import DealBanners from "../pages/Banner Management/Deal Banners/DealBanners";
import AddNewBanner from "../pages/Banner Management/Add Banner/AddNewBanner";
import AddDealsBanner from "../pages/Banner Management/Add Deals Banner/AddDealsBanner";
import UsersManagement from "../pages/User Management/UsersManagement";
import UserManagementOutlet from "../pages/User Management/UserManagementOutlet";
import UsersListDetails from "../pages/User Management/User Management detail page/UsersListDetails";
import BasicPersonal from "../pages/User Management/User Management detail page/BasicPersonal/BasicPersonal";
import BookingHistory from "../pages/User Management/User Management detail page/BookingHistory/BookingHistory";
import UserHistory from "../pages/User Management/User Management detail page/BookingHistory/User History/UserHistory";
import EditBanners from "../pages/Banner Management/Edit Banners/EditBanners";
import EditDealBanner from "../pages/Banner Management/Edit Deal Banner/EditDealBanner";
import Dashboard from "../pages/dashboard/Dashboard";
import Login from "../pages/Login/Login";
import MyAccount from "../pages/my-account/MyAccount";
import PaymentManagement from "../pages/payment-management/PaymentManagement";
import PaymentDetails from "../pages/payment-management/payment-details/PaymentDetails";
import SalesAnalytics from "../pages/sales-analytics/SalesAnalytics";
import ChangePassword from "../pages/my-account/ChangePassword";
import ViewProductDetailInBooking from "../pages/order-managment/View Product/ViewProductDetailInBooking";

import CategoryMetaData from "../pages/MetaDataManagment/Category/CategoryMetaData";
import SubCategoryMetaData from "../pages/MetaDataManagment/SubCategory/SubCategoryMetaData";
import EditMetaCategory from "../pages/MetaDataManagment/editMedataCategory/EditMetaCategory";
import EditMetaSubCategory from "../pages/MetaDataManagment/editMetaDataSubCategory/EditMetaSubCategory";
import LeadManagement from "../pages/Lead-Management/LeadManagement";
import EventPageManagement from "../pages/Event Page Management/EventPageManagement";
import AddEventPage from "../pages/Event Page Management/Add Event Page/AddEventPage";
import EditEventPage from "../pages/Event Page Management/Edit Event Page/EditEventPage";

import VendorManagementOutlet from "../pages/Vendor Management/VendorManagementOutlet";
import VendorManagement from "../pages/Vendor Management/VendorManagement";
import VendorsList from "../pages/Vendor Management/Vendors/VendorsList";
import AddVendor from "../pages/Vendor Management/Vendors/AddVendor/AddVendor";
import EditVendor from "../pages/Vendor Management/Vendors/EditVendor/EditVendor";
import VendorDetails from "../pages/Vendor Management/Vendors/VendorDetails/VendorDetails";
import VendorCategoriesList from "../pages/Vendor Management/VendorCategories/VendorCategoriesList";
import AddVendorCategory from "../pages/Vendor Management/VendorCategories/AddVendorCategory/AddVendorCategory";
import EditVendorCategory from "../pages/Vendor Management/VendorCategories/EditVendorCategory/EditVendorCategory";
import VendorCitiesList from "../pages/Vendor Management/VendorCities/VendorCitiesList";
import CreateVendorCity from "../pages/Vendor Management/VendorCities/CreateVendorCity/CreateVendorCity";
import UpdateVendorCity from "../pages/Vendor Management/VendorCities/UpdateVendorCity/UpdateVendorCity";

function RouterComponent() {
  const location = useLocation().pathname;

  const RestrictedRoute = ["/login", "/OTPVarification"].includes(location);

  return (
    <>
      {!RestrictedRoute && (
        <>
          <Header />
          <SideNavBar />
        </>
      )}

      <Routes>
        {/* Plane Route */}
        <Route path="/" element={<Dashboard />} />
        <Route path="/login" element={<Login />} />
        <Route path="/MyAccount" element={<MyAccount />} />
        <Route path="/ChangePassword" element={<ChangePassword />} />
        <Route path="/PaymentManagement" element={<PaymentManagement />} />
        <Route path="/PaymentDetails" element={<PaymentDetails />} />
        <Route path="/SalesAnalytics" element={<SalesAnalytics />} />

        {/* User Management */}
        <Route path="/UsersManagement" element={<UserManagementOutlet />}>
          <Route index element={<UsersManagement />} />
          <Route path="UsersListDetails" element={<UsersListDetails />}>
            <Route index element={<BasicPersonal />} />
            <Route path=":id/BasicPersonal" element={<BasicPersonal />} />
            <Route path=":id/BookingHistory" element={<BookingHistory />} />
            <Route path=":id/UserHistory" element={<UserHistory />} />
          </Route>
        </Route>

        <Route path="/CityManagement" element={<CityManagement />}>
          <Route path="CreateCity" element={<CreateCity />} />
          <Route path="UpdateCity" element={<UpdateCity />} />
        </Route>

        {/*Banner Management */}
        <Route path="/BannerManagement" element={<BannerManagement />}>

          <Route index element={<TopBanners />} />

          <Route path="TopBanner" element={<TopBanners />}>
            <Route path="AddBanner" element={<AddNewBanner />} />
            <Route path="EditBanners" element={<EditBanners />} />
          </Route>

          <Route path="DealBanner" element={<DealBanners />}>
            <Route path="AddDealsBanner" element={<AddDealsBanner />} />
            <Route path="EditDealsBanner" element={<EditDealBanner />} />
          </Route>
        </Route>

        <Route path="/LeadManagement" element={<LeadManagement />}>
        </Route>


        <Route path="/MetadataManagement" element={<MetaDataManagement />}>
          <Route index element={<Navigate to="CategoryMetaData" replace />} />

          <Route path="CategoryMetaData" element={<CategoryMetaData />}>
            <Route path="AddMetaCategory" element={<AddMetaCategory />} />
            <Route path="EditCatMetaData/:id" element={<EditMetaCategory />} />
          </Route>

          <Route path="SubCategoryMetaData" element={<SubCategoryMetaData />}>
            <Route path="AddMetaSubCategory" element={<AddMetaSubCategory />} />
            <Route path="EditSubCatMetaData/:id" element={<EditMetaSubCategory />} />
          </Route>
        </Route>

        {/* Event Page Management */}
        <Route path="/EventPageManagement" element={<EventPageManagement />}>
          <Route path="AddEventPage" element={<AddEventPage />} />
          <Route path="EditEventPage/:id" element={<EditEventPage />} />
        </Route>


        {/*Product Category*/}
        <Route path="/ProductCategory" element={<ProductCategoryOutlet />}>
          {/*Sub category */}
          <Route index element={<ProductCategory />} />
          <Route path="/ProductCategory" element={<ProductCategory />}>
            <Route path="AddCategory" element={<AddCategory />} />
            <Route path="ProductEdit/:id" element={<EditCategory />} />
          </Route>
          <Route path="SubCategoryProduct/:id" element={<SubCategoryProduct />}>
            <Route path="AddSubCategory" element={<AddSubCategory />} />
          </Route>
        </Route>

        {/* product catalogue management */}
        <Route
          path="/ProductCatalogueManagement/:page"
          element={<ProductForCommanOutelet />}
        >
          <Route index element={<ProductCatalogueManagement />} />
          <Route index element={<ProductCatalogueManagement />} />
          <Route path="AddProductCatalogue" element={<AddProductCatalogue />} />
          <Route
            path="ProductCatalogueEdit/:id"
            element={<ProductCatalogueEdit />}
          />
          <Route
            path="ProductCatalogueDetails/:id"
            element={<ProductCatalogueDetails />}
          />
        </Route>

        {/* Booking management */}
        <Route path="/OrderManagment" element={<OrderManagment />}>
          <Route index element={<Navigate to="ConfirmedBooking" replace />} />
          <Route index element={<ConfirmedBooking />} />
          <Route path="ConfirmedBooking" element={<ConfirmedBooking />}>
            <Route
              path="AddDecoratorPartnerDetails/:id"
              element={<AddDecoratorPartnerDetails />}
            />
            <Route path="CancelOrder/:id" element={<CancelOrder />} />
          </Route>
          <Route path="InTransitOrders" element={<InTransitOrders />} />
          {/* </Route> */}
          <Route path="OrderCompleted" element={<OrderCompleted />} />
          <Route path="OrderReturnd" element={<OrderReturnd />} />
          <Route
            path="OrderActiveConfirmDetails/:id"
            element={<OrderActiveConfirmDetails />}
          />
          <Route
            path="OrderActiveInTransitDetails"
            element={<OrderActiveInTransitDetails />}
          />

          <Route
            path="ViewProductDetailInBooking"
            element={<ViewProductDetailInBooking />}
          />

        </Route>

        {/* Abandoned Cart Managment */}
        <Route
          path="/AbandonedCartManagment"
          element={<AbandonedCartOutletCommon />}
        >
          <Route index element={<AbandonedCartManagment />} />
          <Route path="AbandonedDetails" element={<AbandonedDetails />} />
          <Route path="AbandonedCartNotify" element={<AbandonedCartNotify />} />
        </Route>
        {/* Content Management */}
        <Route path="/ContentManagement" element={<ContentManagementOutlet />}>
          <Route index element={<ContentManagement />} />
          <Route path="ContentManagement" element={<ContentManagement />} />
          <Route
            path=":id/EditContentManagement"
            element={<EditContentManagement />}
          />
        </Route>

        {/* Notification Management */}
        <Route path="/Notification" element={<Notification />}>
          <Route path="AddNotification" element={<AddNotification />} />
          <Route path="UpdateNotification" element={<UpdateNotification />} />
        </Route>

        {/* Vendor Management */}
        <Route path="/VendorManagement" element={<VendorManagementOutlet />}>
          <Route index element={<Navigate to="Vendors" replace />} />
          <Route element={<VendorManagement />}>
            <Route path="Vendors" element={<VendorsList />} />
            <Route path="VendorCategories" element={<VendorCategoriesList />}>
              <Route path="AddVendorCategory" element={<AddVendorCategory />} />
              <Route path="EditVendorCategory/:id" element={<EditVendorCategory />} />
            </Route>
            <Route path="VendorCities" element={<VendorCitiesList />}>
              <Route path="CreateVendorCity" element={<CreateVendorCity />} />
              <Route path="UpdateVendorCity" element={<UpdateVendorCity />} />
            </Route>
          </Route>
          <Route path="Vendors/AddVendor" element={<AddVendor />} />
          <Route path="Vendors/EditVendor/:id" element={<EditVendor />} />
          <Route path="Vendors/VendorDetails/:id" element={<VendorDetails />} />
        </Route>
      </Routes>
    </>
  );
}

export default RouterComponent;